export const TOAST_CONFIG = {
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: "0.875rem",
  fontWeight: 400,
  lineHeight: 1.4,
  letterSpacing: "0.01em",
  borderRadius: "8px",
  padding: "16px",
  gap: "8px",
  duration: 3000,
  opacity: 0.98,
  backdropFilter: "blur(8px)",

  getPosition: (isMobile) => (isMobile ? "top-center" : "bottom-right"),
};

export const getToastStyle = (theme) => {
  return {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `0.5px solid ${theme.palette.divider}`,
    fontFamily: TOAST_CONFIG.fontFamily,
    fontSize: TOAST_CONFIG.fontSize,
    fontWeight: TOAST_CONFIG.fontWeight,
    lineHeight: TOAST_CONFIG.lineHeight,
    letterSpacing: TOAST_CONFIG.letterSpacing,
    borderRadius: TOAST_CONFIG.borderRadius,
    padding: TOAST_CONFIG.padding,
    opacity: TOAST_CONFIG.opacity,
    backdropFilter: TOAST_CONFIG.backdropFilter,
    boxShadow: theme.shadows[6],

    // Close button styling for desktop
    "--close-button-color": theme.palette.text.secondary,
    "--close-button-hover-color": theme.palette.text.primary,
    "--close-button-size": "20px",
  };
};
